/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".editingInput_83049000{border:0px;outline:none;width:100%}.editingInput_83049000::-ms-clear{display:none}.editingContainer_83049000{margin:4px}\n" }]);
export var editingInput = "editingInput_83049000";
export var editingContainer = "editingContainer_83049000";
//# sourceMappingURL=EditingItem.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/SelectedItemsList/SelectedPeopleList/Items/EditingItem.scss.js
// module id = 877
// module chunks = 0